export const PROFILE_SCHEMA_API = '/profileSchema.json';

export const USER_API = 'https://ko3t4vcvqb.execute-api.us-east-1.amazonaws.com';
